import { FormControl, FormGroup } from '@angular/forms';
import { NodeType } from '@features/flow-ui-creator/interfaces/node.interface';
import { GraphColors } from '../../flow-ui-creator/services/graph.utils';
import { ApplicationActionParameterDataType } from '../enums/application-action.enum';

export interface Parameter<DT = DataType> {
  data_type?: DataType;
  key: string;
  type?: DataType | DT;
  value: string | string[];
  id?: string;
  is_inbound?: boolean;
  is_required?: boolean;
  category?: DataType | 'error-emails' | 'error-condition' | 'stream';
  parent_id?: string;
  is_edit?: boolean;
  tabKey?: string;
  is_root?: boolean;
  subject?: DataType | DT;
  children?: Parameter<DT>[];
}

export type DataType = EnumAsUnion<typeof ApplicationActionParameterDataType>;

export interface Header {
  key: string;
  value?: string;
  type?: DataType;
}

export interface Body {
  key: string;
  type: Omit<DataType, 'hardcoded'>;
}

export interface ActionPostBody {
  application_id: number;
  endpoint: string;
  chat_allowed: boolean;
  interface: ApplicationInterfaceEnum;
  method: ApplicationMethodEnum;
  name: string;
  parameters: [];
}

export interface Application {
  id: number;
  created_by_id: number | null;
  name: string;
  version: string;
  base_url: string;
  authentication_method: string;
  created_at: string;
  updated_at: string;
  actions?: ApplicationAction[];
  isCollapsed?: boolean;
  styles?: GraphColors;
  color?: string;
  type?: NodeType;
}

export enum ApplicationMethodEnum {
  GET = 'GET',
  POST = 'POST',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}

export enum ApplicationInterfaceEnum {
  SOAP = 'SOAP',
  REST = 'REST',
  XML = 'XML',
}

export interface ApplicationAction {
  id?: number;
  created_by_account_id?: number;
  application_id?: number;
  name: string;
  label?: string;
  interface: ApplicationInterfaceEnum;
  method: ApplicationMethodEnum;
  endpoint: string;
  chat_allowed: boolean;
  created_at?: string;
  updated_at?: string;
  application?: Application;
  styles?: GraphColors;
  parameters?: Parameter[];
  type?: NodeType;
  headers?: Parameter[];
  body?: Parameter[];
  path?: Parameter[];
  envelopeNamespace?: Parameter[];
  soapHeader?: Parameter[];
  soapFault?: Parameter[];
  responseBody?: Parameter[];
  responseHeaders?: Parameter[];
  responseEnvelopeNamespace?: Parameter[];
  responseSoapHeader?: Parameter[];
  responseSoapFault?: Parameter[];
  details?: ApplicationAction;
}

export interface NodeConfigFormValue {
  name: string;
  interface: {
    value: ApplicationInterfaceEnum;
    label: ApplicationInterfaceEnum;
  };
  method: ApplicationMethodEnum;
  endpoint: string;
  chat_allowed: boolean;
  parameters?: Parameter[];
  headers?: Header[];
  body?: Body[];
}

export type ApplicationActionFormGroup<T extends Record<string, any>> = {
  [K in keyof T]?: T[K] extends Record<any, any>
    ? FormGroup<ApplicationActionFormGroup<T[K]>>
    : FormControl<T[K] | null>;
};

export interface ApplicationActionDuplicatePayload {
  name: string;
  version?: string;
  color?: string;
}
